import React, { useState } from 'react';
import { Facebook, Twitter, Youtube, MessageCircle, MapPin, Phone, Mail, Send } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const [formData, setFormData] = useState({
    email: '',
    message: ''
  });

  const currentYear = new Date().getFullYear();

  const contactInfo = [
    {
      title: "Corporate Office",
      address: "Door No: 1-35, 2ND FLOOR ABOVE SBI BANK OPP CRICKET STADIUM PM PALEM, Madhuravada (u) Village, VISAKHAPATNAM Mandal, Visakhapatnam District, Pincode - 530041",
      phone: "+91-9133102888",
      email: "genetheraptics@yahoo.in"
    },
    {
      title: "Our Plants",
      address: (
        <div className="plant-address">
          <div className="plant-item">
            <strong>Plant 1:</strong> Opp Indian Oil Petrol Bunk Pipeline Road, Jeedimetla, Hyderabad
          </div>
          <div className="plant-item">
            <strong>Plant 2:</strong> PLOT NO:1,2,3,4,5 BLOCK 23A APIIC PHASE IV, 1 MC Division Village, Guntur East Mandal, Guntur District, Pincode - 522001
          </div>
          <div className="plant-item">
            <strong>Plant 3:</strong> Industrial Area, Phase-II, Chandigarh-160002
          </div>
        </div>
      ),
      phone: (
        <div className="plant-phone">
          <div><strong>Plant 1:</strong> +91-8187896699</div>
          <div><strong>Plant 2:</strong> +91-9133331159</div>
          <div><strong>Plant 3:</strong> +91-9133028899</div>
        </div>
      ),
      email: "genetheraptics@yahoo.in"
    },
    {
      title: "Sales Offices",
      address: (
        <div className="sales-address">
          <div className="sales-item">
            <strong>Bangalore, Karnataka</strong>
          </div>
          <div className="sales-item">
            <strong>Chhattisgarh, Raipur</strong> (Near Wall Fort City)
          </div>
          <div className="sales-item">
            <strong>Namakkal, Tamil Nadu</strong> (Paramathi Road SP Pudur)
          </div>
        </div>
      ),
      phone: "+91-9133331156",
      email: "genetheraptics@yahoo.in"
    }
  ];

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setFormData({ email: '', message: '' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Brand Section */}
        <div className="brand-section">
          <div className="brand-header">
            <h3 className="brand-name">GENE THERAPTICS</h3>
            <p className="brand-tagline">Leading Innovation in Pharmaceutical Solutions</p>
          </div>
        </div>

        {/* Contact Information */}
        <div className="contact-section">
          <h4 className="section-title" style={{color:"white"}}>Our Offices</h4>
          <div className="contact-grid">
            {contactInfo.map((contact, index) => (
              <div key={index} className="contact-card">
                <h5 className="contact-title" style={{color:"white"}}>{contact.title}</h5>
                <div className="contact-details">
                  <div className="contact-item">
                    <MapPin size={16} className="contact-icon" />
                    <span>{contact.address}</span>
                  </div>
                  <div className="contact-item">
                    <Phone size={16} className="contact-icon" />
                    <span>{contact.phone}</span>
                  </div>
                  <div className="contact-item">
                    <Mail size={16} className="contact-icon" />
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Section */}
        <div className="bottom-section">
          <div className="products-section">
            <h4 className="section-title" style={{color:"white"}}>Our Products</h4>
            <div className="product-links">
              <a href="#poultry" className="product-link">
                <span>Poultry Division</span>
              </a>
              <a href="#large-animal" className="product-link">
                <span>Large Animal Division</span>
              </a>
              <a href="#aquaculture" className="product-link">
                <span>Aqua Division</span>
              </a>
            </div>
          </div>

          <div className="form-section">
            <h4 className="section-title" style={{color:"white"}}>Get in Touch</h4>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <input 
                  type="email" 
                  name="email"
                  placeholder="Enter your email address" 
                  value={formData.email}
                  onChange={handleInputChange}
                  required 
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <textarea 
                  name="message"
                  placeholder="Your message or inquiry" 
                  value={formData.message}
                  onChange={handleInputChange}
                  required 
                  rows="3"
                  className="form-textarea"
                ></textarea>
              </div>
              <button type="submit" className="submit-btn">
                <Send size={16} />
                <span>Send Message</span>
              </button>
            </form>
          </div>
        </div>
      </div>
      
      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="copyright">
            <p>&copy; {currentYear} Genetheraptics Pharma Pvt. Ltd. All rights reserved.</p>
          </div>
          
          <div className="footer-links">
            <a href="#support">Support</a>
            <a href="#privacy">Privacy Policy</a>
            <a href="#terms">Terms of Service</a>
          </div>
          
          <div className="social-links">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
              <Facebook size={18} />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
              <Twitter size={18} />
            </a>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
              <Youtube size={18} />
            </a>
            <a href="https://telegram.org" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
              <MessageCircle size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;